import { TwainGameId } from 'betgames-contract-js';
import {
    IParticipantResultStats,
    IParticipantsPair,
    IResults,
    IScores,
    ITournamentMatchShotData,
} from 'twain-sport-fe-mono/interfaces';
import { ResultReason } from 'twain-sport-fe-mono/enums';
import { BIG_POINTS_AMOUNT } from '../constants';

interface IOutroData {
    gameId: TwainGameId;
    left: IParticipantResultStats;
    right: IParticipantResultStats;
    results: IResults;
    pointsDiff: number;
}

const getLeaderChangedAmount = (
    shotsHistory: IScores<ITournamentMatchShotData[]>,
    participants: IParticipantsPair,
): number => {
    const leftShorts: ITournamentMatchShotData[] = shotsHistory?.[participants?.left.code];
    const rightShorts: ITournamentMatchShotData[] = shotsHistory?.[participants?.right.code];

    if (!leftShorts || !rightShorts) {
        return 0;
    }

    const resultInfo = leftShorts.reduce(
        (acc, leftShot, index) => {
            acc.leftTotal += leftShot.isSuccessful ? leftShot.points : 0;
            acc.rigthTotal +=
                rightShorts[index] && rightShorts[index].isSuccessful
                    ? rightShorts[index].points
                    : 0;

            let newLeader = acc.leader;

            if (acc.leftTotal > acc.rigthTotal) {
                newLeader = 'left';
            } else if (acc.leftTotal < acc.rigthTotal) {
                newLeader = 'right';
            }

            if (newLeader !== acc.leader) {
                if (acc.leader) {
                    acc.changed += 1;
                }
                acc.leader = newLeader;
            }

            return acc;
        },
        { changed: 0, leader: null, leftTotal: 0, rigthTotal: 0 },
    );

    return resultInfo.changed;
};

export const getOutroAudio = (
    data: IOutroData,
    shotsHistory: IScores<ITournamentMatchShotData[]>,
    participants: IParticipantsPair,
): string => {
    const leaderChangedAmount = getLeaderChangedAmount(shotsHistory, participants);

    const list = {
        '1': leaderChangedAmount >= 4,
        '2': Number(data.left.accuracy) === 100,
        '3': Number(data.right.accuracy) === 100,
        '4': data.results.resultReason === ResultReason.TIE_ACCURACY,
        '5': data.results.resultReason === ResultReason.TIE_RANK,
        '6': data.pointsDiff >= 10,
        '7': data.pointsDiff === 2 || data.pointsDiff === 3,
        '8': data.pointsDiff === 1,
        '9':
            data.left.points >= BIG_POINTS_AMOUNT[data.gameId] ||
            data.right.points >= BIG_POINTS_AMOUNT[data.gameId],
    };

    const audios = Object.entries(list).reduce((acc, [key, value]) => {
        if (value) {
            acc.push(key);
        }
        return acc;
    }, []);

    return audios.length ? audios[Math.floor(Math.random() * audios.length)] : null;
};
